import { Injectable } from '@angular/core';
import { User } from '../model/types';
import { S3Factory } from '../../utils';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthNewService } from './auth-new.service';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import {SearchResult} from '../model/analysis-details.model';
import {environment} from '../../environments/environment';
declare var TextDecoder;

@Injectable({
  providedIn: 'root'
})
export class DownLoadService {

  private signedInUser?: User;
  private region: string;
  private signedUrlExpireSeconds = 60 * 5;
  dataLoaded = new Subject<SearchResult[]>();
  BUCKET: string = environment.bucket;
  graph_variable: string;
  contentDisposition: string;
  preSignURL: string = environment.serverUrl + '/presigned-url';

  constructor(private http: HttpClient,
              private authService: AuthNewService) {
    this.region = environment.defaultRegion || 'us-east-2';
  }

  setSignedInUser(user: User) {
    this.signedInUser = user;
  }

  // Upload status updates

  setRegion(region: string) {
    this.region = region;
  }

  listFiles() {
//     console.log('Getting files for path -  ', [this.signedInUser.username, this.signedInUser.userId].join('/'))
    return S3Factory.getS3(this.region).listObjectsV2({
      Bucket: this.BUCKET,
      Prefix: [this.signedInUser?.username, this.signedInUser?.userId].join('/')
    }).promise();
  }

  getUrl(key: string, replace_filename = true, analysisType?: string, fileExcelName?: string) {
    let filename: string;
    const isPdf = key.toLowerCase().endsWith('.pdf');
    if (analysisType === 'AP') {
      filename = isPdf
        ? `RedThread User Uploaded File(s)_${fileExcelName}.pdf`
        : 'RedThread_Analysis_Report.xlsx';
    } else {
      filename = isPdf
        ? `RedThread User Uploaded File(s)_${fileExcelName}.pdf`
        : `RedThread_Analysis_Report_${fileExcelName}.xlsx`;
    }

    this.contentDisposition = `attachment; filename="${filename}"`;
    let params = new HttpParams().set('key', key);

    return this.http.get(this.preSignURL, { params }).pipe(
      tap((res: any) => {
        const presignedUrl = res.url;
        console.log(presignedUrl)
        this.downloadFile(presignedUrl, filename);
      })
    );
  }

  private downloadFile(url: string, filename: string) {
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
      });
  }

  async getS3Obj(key: string) {
    try {
      const params = {
        Bucket: this.BUCKET,
        Key: key
      }
      const data = await S3Factory.getS3(this.region).getObject(params).promise();
      const result =  new TextDecoder('utf-8').decode(data.Body);
      return  result
    } catch (e) {
      throw new Error(`Could not retrieve file from S3: ${e.message}`)
    }
 /*   S3Factory.getS3(this.region).getObject({
      Bucket: this.BUCKET,
      Key: key
    }, function (err, data) {
      if (err) { console.log(err, err.stack); } else {
        const string = new TextDecoder('utf-8').decode(data.Body);

        console.log('DATA', string);
      }
    })
*/  }






}
